import { BRAND } from "@/lib/data";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="border-b border-damita-border">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16 py-16 md:py-24 lg:py-32">
        <div className="grid grid-cols-12 gap-6 lg:gap-12">
          <div className="col-span-12 lg:col-span-4">
            <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-damita-ink2 mb-6 flex items-center gap-3">
              <span className="w-8 tick-line" /> About Us
            </div>
            <h2 className="font-display font-black text-3xl md:text-4xl lg:text-5xl tracking-tighter leading-[0.95]">
              Built in 2017. <br />
              Engineered for the<br />
              toughest terrain.
            </h2>
          </div>

          <div className="col-span-12 lg:col-span-8 lg:pl-8 lg:border-l border-damita-border">
            <p className="text-lg md:text-xl leading-relaxed text-damita-ink">
              <strong className="text-damita-ink">{BRAND.full} ({BRAND.short})</strong> is a
              premier, fast-growing power solutions provider, established in 2017. We have become a dominant force in power protection across the Eastern and North-Eastern zones of India — a registered startup with Udyam certification, specialising in high-performance electrical systems.
            </p>
            <p className="mt-6 text-base md:text-lg leading-relaxed text-damita-ink2">
              With presence in every state of the Northeast — Arunachal Pradesh, Assam,
              Manipur, Meghalaya, Mizoram, Nagaland and Tripura, plus the brother state of
              Sikkim — we bring highly skilled expertise to the most challenging terrains.
            </p>

            <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-px bg-damita-border border border-damita-border">
              {[
                ["Founded", "2017"],
                ["Coverage", "12 States"],
                ["HQ", "Agartala, TR"],
                ["Status", "Udyam-Registered"],
              ].map(([k, v]) => (
                <div key={k} className="bg-white p-5">
                  <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-damita-ink2">{k}</div>
                  <div className="font-display font-black text-xl md:text-2xl tracking-tight mt-2">{v}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
